<template>
    <div class="container-fluid">
        <br>
        <router-link to="/servers" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{$t('words.cancel') }}
        </router-link>
        <button type="button" :disabled="loading" @click="saveData" class="btn btn-lg btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <br>
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">

                        <li role="presentation" class="nav-item">
                            <a class="nav-link active" href="#tabFormulario" aria-controls="tabFormulario" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-server"></i>
                                Dados do Servidor
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                        <div class="tab-pane active" id="tabFormulario">
                            <span v-html="$t('validation.field_required')"></span>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <required /> <label>{{$t('attributes.name')}}</label>
                                        <input class="form-control" :class="{'is-invalid': errors.has('Nome')}"
                                            name="Nome" v-validate="{required: true, max:60}"
                                            :placeholder="$t('words.type_name')" v-model="server.name">
                                        <div class="invalid-feedback help-block error">{{errors.first('Nome')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <required /> <label>IP Address</label>
                                        <input class="form-control" :class="{'is-invalid': errors.has('Ip')}" name="Ip"
                                            v-validate="{required: true, max:60}" :placeholder="'Insira o endereço'"
                                            v-model="server.ip_address">
                                        <div class="invalid-feedback help-block error">{{errors.first('Ip')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label>Port</label><br />
                                        <input class="form-control" :class="{'is-invalid': errors.has('port')}"
                                            name="Ip" v-validate="{required: true, max:60}"
                                            :placeholder="'Insira o endereço'" v-model="server.port">
                                        <div class="invalid-feedback help-block error">{{errors.first('port')}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                server: {
                    name: null,
                    ip_address: null,
                    port: 8000,
                },
                loading: false,
            };
        },
        beforeMount() {
            if (this.$route.name === 'serverEdit') {
                this.getServer();
            }
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        methods: {
            getServer() {
                this.$store
                    .dispatch('getServerById', this.$route.params.id)
                    .then(response => {
                        console.log(response)
                        this.server = response;
                    });
            },
            saveData() {
                this.loading = true;
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.$route.name === 'serverEdit' ?
                            this.updateData('updateServer', this.server, '/servers') :
                            this.storeData('storeServer', this.server);
                    } else this.loading = false;
                });
            },
            updateData() {
                this.$store.dispatch('updateServer', this.server).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        this.$router.push('/servers');
                    }
                });
            },
            storeData() {
                this.$store.dispatch('storeServer', this.server).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        this.resetForm();
                    }
                });
            },
        },

    };
</script>